/**
 * Import necessary modules and types from 'vsb-sdk' and 'post-robot'.
 */
import { HandlerEvent } from 'post-robot';
import { getEmvcoLoadTiming } from 'common/instrumentation';
import { handleGlobalsReady } from 'orch-communicator/index';
import { saveMerchantProperties } from 'orch-communicator/store';
import vsbSdk from 'vsb-sdk/api';
import { listenToOrchCommunicator } from 'vsb-sdk/utils/orch-communicator';
import 'types/integration-globals';

//START GENAI@GHCOPILOT
function loadOrchCommunicatorSdk() {}
//END GENAI@GHCOPILOT
/**
 * START GENAI@GHCOPILOT
 * Listen to the Orchestrator Communicator for the 'vsb-communicator:internal:token-update' event.
 * When the event is triggered, send a message to the checkout with the updated token expiration information.
 * @param event - The event object containing the updated token expiration information.
 * END GENAI@GHCOPILOT
 */
//START GENAI@GHCOPILOT

listenToOrchCommunicator(
  'vsb-communicator:internal:receive-vsbs-globals',
  /* eslint-disable @typescript-eslint/no-explicit-any */
  async (event: HandlerEvent<{ VSB_GLOBALS: any }>) => {
    /*eslint-disable*/
    console.log('receive-vsbs-globals ...');
    window.VSB_GLOBALS = event?.data?.VSB_GLOBALS || null;
    if (window?.VSB_GLOBALS) {
      saveMerchantProperties(window);
      await handleGlobalsReady();
      console.log('!!!!!!!!!!! all ready');
    } else {
      console.error('VSB_GLOBALS is not available');
    }
  }
);
//END GENAI@GHCOPILOT
window.VSDK = vsbSdk;

getEmvcoLoadTiming();

export default loadOrchCommunicatorSdk;
